import { ElementStore } from 'component/Carousel/store/ElementStore'

function round(n: number): number {
  const mult = 1000
  return Math.round(n * mult) / mult
}

export function getIndexPosition(element: ElementStore): number {
  const { index } = element
  return round(index + 1 / 2)
}

export function shiftLinear(element: ElementStore, position: number, shift_linear: number): void {
  const { width } = element
  const shift = shift_linear / width
  setPosition(element, position + shift)
}

export function setPosition(element: ElementStore, position: number): void {
  position = round(position)

  const { root, view, width, angle } = element

  let scale_left = 0
  let scale_center = 0

  const children = root.children
  const length = children.length
  const index_best = Math.max(0, Math.min(length - 1, Math.trunc(position)))

  const max_scale = 0.77

  for (let index = 0; index < length; ++index) {
    const child = children.item(index) as HTMLElement
    const left = index < index_best

    const distance = position - index - 1 / 2
    const percent = 100 - (100 * (1 - max_scale)) * Math.min(1, Math.abs(distance))

    const z = index === index_best ? '1' : null
    const scale = round(percent / 100)
    const rotation = angle ? -1 * angle * distance : 0

    if (left) scale_left += scale
    if (index === index_best) scale_center = scale

    child.style.setProperty('--slide-z', z)
    child.style.setProperty('--slide-scale', scale.toFixed(3))
    child.style.setProperty('--slide-rotation', rotation.toFixed(3))
  }

  const bound = view.getBoundingClientRect()
  const width_left = width * scale_left
  const width_center = width * scale_center
  const left = bound.width / 2 - width_left - width_center * (position - index_best)

  element.position = position
  element.left = left
  root.style.left = left.toFixed(3) + 'px'
}
